export default {"src":"/_next/static/media/number2--salmon.63cd65ef.svg","height":44,"width":29,"blurWidth":0,"blurHeight":0};